import { AuthUser } from '@app/core/types/users';
import { User as Auth0User, useAuth0 } from '@auth0/auth0-react';
import { WebAppInitAppBootstrapQueryResponse } from '@mi-front/api-v2';
import { ReactElement, useState } from 'react';
import { AuthContext, AuthData, UpdateUserData } from '../context/auth-context';
import { Client } from '@app/core/types/client';

export function AuthContextInit({
  appInitResponse,
  children,
}: {
  appInitResponse: WebAppInitAppBootstrapQueryResponse | null;
  children: ReactElement;
}) {
  const { user: auth0User } = useAuth0();
  const { user, client } = appInitResponse ?? {};
  const [auth, setAuth] = useState<AuthData>({
    user: user as AuthUser,
    client: client as Client | null,
  });

  /** Merges the given user fields into the current auth user and updates context. */
  const updateAuthUser = (updates: UpdateUserData) => {
    setAuth((prev) => {
      if (!prev) {
        return prev;
      }

      return {
        ...prev,
        user: {
          ...prev.user,
          ...updates,
        } as AuthData['user'],
      };
    });
  };

  return (
    <AuthContext.Provider value={{ auth0User: auth0User as Auth0User, auth, updateAuthUser }}>
      {children}
    </AuthContext.Provider>
  );
}
